// @flow
import { call, put, takeLatest, take, race } from "redux-saga/effects";
import {fetchJSON} from "../../helpers/api";
import {
    BATCH_CANCEL,
    BATCH_CLOSE_MODAL,
    BATCH_FAIL_ITEM,
    BATCH_FINISH, BATCH_INIT_STATE,
    BATCH_PROGRESS, BATCH_START,
    BATCH_SUCCESS_ITEM
} from "./constants";

function* processBatch(action) {
    const { apiUrl, ids, params, onComplete } = action.payload;

    yield put({ type: BATCH_INIT_STATE, payload: { total: ids.length } });

    let success = [];
    let failed = [];

    for (let i = 0; i < ids.length; i++) {

        const item = ids[i];
        const id = typeof item === 'object' ? item.id : item;
        const label = typeof item === 'object' ? item.label : '';

        const options = {
            body: JSON.stringify({ id, params }),
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        try {

            const { response, cancel } = yield race({
                response: call(fetchJSON, process.env.REACT_APP_BACKEND + '/' + apiUrl, options),
                cancel: take(BATCH_CANCEL)
            });

            if (cancel) {

                yield put({
                    type: BATCH_FINISH,
                    payload: {
                        status: "cancelled",
                        success,
                        failed
                    }
                });

                yield put({ type: BATCH_CLOSE_MODAL });

                if (onComplete) {
                    yield call(onComplete, {});
                }

                return;
            }

            if (response.result) {

                yield put({
                    type: BATCH_SUCCESS_ITEM,
                    payload: { id, response: response.data }
                });

            } else {

                failed.push({
                    id,
                    error: response.error,
                    response: response
                });

                yield put({
                    type: BATCH_FAIL_ITEM,
                    payload: {
                        id,
                        error: response.error,
                        response: response
                    }
                });

            }

        } catch (error) {

            failed.push({
                id,
                error: error.message,
                response: error.response?.data
            });

            yield put({
                type: BATCH_FAIL_ITEM,
                payload: {
                    id,
                    error: error.message,
                    response: error.response?.data
                }
            });

        }

        yield put({
            type: BATCH_PROGRESS,
            payload: {
                current: i + 1,
                total: ids.length,
                label: label
            }
        });

    }

    if (failed.length === 0) {

        yield put({ type: BATCH_FINISH, payload: { status: "success" } });

    } else {

        yield put({
            type: BATCH_FINISH,
            payload: {
                status: "error",
                failed
            }
        });

    }

    if (onComplete) {
        yield call(onComplete, {});
    }

}

export function* batchProcessSaga(): any {
    yield takeLatest(BATCH_START, processBatch);
}

export default batchProcessSaga;